import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { NOTIFICATION_TYPES, useNotification } from '@components/Notification';
import { SessionStorage } from '@constants/storage';
import {
  getSessionStorageValue,
  removeSessionStorageValue,
} from '@helpers/sessionStorage';

/**
 * Tells the user their experience was closed after a UE-initiated logout.
 *
 * That logout leaves the page with a full navigation, so React state cannot
 * carry the message across — `useHandleLogoutRequestMsg` leaves a flag in
 * session storage and this component consumes it once on the next page.
 *
 * @returns Nothing; the notice is rendered by the notification provider.
 */
const LeftExperienceNotice = () => {
  const { t: translate } = useTranslation();
  const { showNotification } = useNotification();

  useEffect(() => {
    if (!getSessionStorageValue<boolean>(SessionStorage.LeftExperienceNotice)) {
      return;
    }

    removeSessionStorageValue(SessionStorage.LeftExperienceNotice);

    showNotification({
      message: translate('notifications.leftExperience'),
      type: NOTIFICATION_TYPES.INFO,
      withDismissButton: false,
    });
  }, [showNotification, translate]);

  return null;
};

export default LeftExperienceNotice;
